import {
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import {
  insurerFeatureKey,
  InsurerState,
} from '../../reducer/insurer/insurer.reducer';

export const selectInsurerState = createFeatureSelector<InsurerState>(insurerFeatureKey);

export const selectInsurers = createSelector(selectInsurerState, (state: InsurerState) => state.insurers);
